module.exports = __webpack_public_path__ + "static/media/delete-icon.fad91cad.svg";